import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testCustomerAccountOnboardingWebhook = (axios: IAxiosInstance) => {
  return async ({
    customerAccountOnboardingWebhook,
    userType,
    test,
    usePrimary,
  }: ISchema["#/definitions/ITestCustomerAccountOnboardingWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestCustomerAccountOnboardingWebhookResponse"]
    >(
      `/api/testCustomerAccountOnboardingWebhook${getUsePrimaryUrlParams(
        usePrimary
      )}`,
      {
        customer_account_onboarding_webhook: customerAccountOnboardingWebhook,
        user_type: userType,
        test,
      }
    );

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
